const ArrowDownIcon = (props) => (
  <svg width={12} height={12} {...props} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.6667 8.78068L10.2427 5.20468L11.1854 6.14735L6.00003 11.3327L0.814697 6.14735L1.75736 5.20468L5.33336 8.78068V0.666016H6.6667V8.78068Z" />
  </svg>
);

export default ArrowDownIcon;
